<template>
  <div class="m-4">
    <p v-if="loading">Lade…</p>
    <Button v-else @click="loadLicensesStreamed">Laden</Button>
    <Button @click="AccountStore.reset()"> Reset Cache</Button>
        <Button @click="testNotification"> Test Notification</Button>
                <Button @click="addNotificationProgress"> +</Button>


    <div>
      <p>Geladene Einträge: {{ rows.length }}</p>
      <p>Ladezeit: {{ loadingTime }} Sekunden</p>
      <p>Einträge pro Sekunde: {{ itemsPerSecond }}</p>
      <p>Durchschnittliche Verarbeitungszeit pro Eintrag: {{ avgProcessingTime }} ms</p>
      <p>Memory usage: {{ memoryUsage }} MB</p>
    </div>
  </div>
</template>

<script setup>
import { OpenAPI } from '@/client'
import { editToast, sendToast } from '@/components/sm/SmNotification'
import { AccountStore } from '@/stores/account/account.store'
import { ref, onMounted, onBeforeUnmount, computed } from 'vue'

const rows = ref([])              // Achtung: 270k Objekte = viel RAM
const loading = ref(false)
const controller = new AbortController()
const startTime = ref(0)
const endTime = ref(0)
const totalProcessingTime = ref(0)
const memoryWarning = ref(false)
const memoryUsage = ref(0)

const loadingTime = computed(() => {
  if (endTime.value === 0) return 0
  return ((endTime.value - startTime.value) / 1000).toFixed(2)
})

const itemsPerSecond = computed(() => {
  if (loadingTime.value === 0 || rows.value.length === 0) return 0
  return (rows.value.length / loadingTime.value).toFixed(0)
})

const avgProcessingTime = computed(() => {
  if (rows.value.length === 0 || totalProcessingTime.value === 0) return 0
  return (totalProcessingTime.value / rows.value.length).toFixed(3)
})

onMounted(async () => {
})


const toastID = ref()

async function testNotification(){
 toastID.value = sendToast("Test", undefined, "loading", undefined, true, 50, 100)
}

async function addNotificationProgress(){
editToast(toastID.value, {currentProgress: 60, title: "Hallo"})
}

async function loadLicensesStreamed() {
  rows.value = []
  loading.value = true

  startTime.value = 0
  endTime.value = 0
  totalProcessingTime.value = 0
  startTime.value = performance.now()
  let lastUpdateTime = performance.now()

  try {
    const res = await fetch(`${OpenAPI.BASE}/api/v1/software/licences/stream`, {
      headers: { 'Accept': 'application/x-ndjson', "authorization": `Bearer ${OpenAPI.TOKEN}` },
      signal: controller.signal,
    })
    if (!res.ok || !res.body) throw new Error('Stream failed')

    const reader = res.body.getReader()
    const decoder = new TextDecoder() // Browser entpackt gzip automatisch
    let buf = ''

    while (true) {
      const { value, done } = await reader.read()
      if (done) break
      buf += decoder.decode(value, { stream: true })

      // Zeilenweise parsen
      let idx
      while ((idx = buf.indexOf('\n')) >= 0) {
        const line = buf.slice(0, idx).trim()
        buf = buf.slice(idx + 1)
        if (!line) continue
        try {
          const parseStart = performance.now()
          rows.value.push(JSON.parse(line))
          const parseEnd = performance.now()
          totalProcessingTime.value += parseEnd - parseStart

          // Log progress every 1000 items
          if (rows.value.length % 1000 === 0) {
            const currentTime = performance.now()
            const elapsed = (currentTime - lastUpdateTime) / 1000
            lastUpdateTime = currentTime
            AccountStore.bulkInsertLicenceOuts(toRaw(rows.value))
            rows.value = []
            // checkMemoryUsage()
          }
        } catch (e) {
          console.error('Failed to parse line:', e)
        }
      }
    }
  } catch (e) {
    console.error('Stream error:', e)
  } finally {
    endTime.value = performance.now()
    loading.value = false

  }
}

function checkMemoryUsage() {
  if (window.performance && window.performance.memory) {
    const usedMB = window.performance.memory.usedJSHeapSize / (1024 * 1024)
    memoryUsage.value = usedMB.toFixed(1)
    if (usedMB > 500) { // Warn if using more than 500MB
      memoryWarning.value = true
    }
  }
}


onBeforeUnmount(() => controller.abort())
</script>
